import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import Isemail from 'isemail';

import { Button, Box, Typography } from '@material-ui/core';
import AuthCard from 'components/Cards/AuthCard';
// import { useSelector } from 'react-redux';
import TextField from 'components/Inputs/TextField';
import { useUsers } from 'hooks';
import { ConfigContext } from 'context/ConfigContext';

const useStyles = makeStyles((theme) => ({
  instructions: {
    ...theme.typography.subtitle2,
  },
  title: {
    ...theme.typography.h5,
    marginBottom: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: -20,
  },

  footer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const PasswordResetRequest = () => {
  const { userRequestPasswordReset } = useUsers();
  const { client_id } = useContext(ConfigContext);

  const { t } = useTranslation();
  const classes = useStyles();
  const defaultUsername = ''; // useSelector(Selectors.getUserName);
  const [valid, setValid] = useState(!_.isEmpty(defaultUsername));
  const [email, setEmail] = useState(defaultUsername);
  const [emailSent, setEmailSent] = useState(false);

  const updateEmail = (email) => {
    setEmail(email);

    if (Isemail.validate(email)) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const onSubmit = (email) => {
    userRequestPasswordReset(email, client_id);
    setEmailSent(true);
  };

  if (emailSent) {
    return (
      <AuthCard
        footer={
          <div className={classes.footer}>
            <Button size="small" component={Link} to="/">
              {t('return_to_login')}
            </Button>
          </div>
        }
      >
        <Box component="div" className={classes.root}>
          <Typography className={classes.title}>
            {t('reset_instructions_email_sent')}
            {email}
          </Typography>
        </Box>
      </AuthCard>
    );
  } else {
    return (
      <AuthCard
        footer={
          <div className={classes.footer}>
            <Button size="small" component={Link} to="/">
              {t('return_to_login')}
            </Button>
          </div>
        }
      >
        <Box component="div" className={classes.root}>
          <Typography className={classes.title}>{t('forgot_password')}</Typography>
          <Typography className={classes.instructions}>{t('reset_instructions')}</Typography>
        </Box>
        <TextField required name="email" value={email} label={t('email')} setValue={(v) => updateEmail(v)} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={!valid}
          className={classes.submit}
          onClick={() => onSubmit(email)}
        >
          {t('send_code')}
        </Button>
      </AuthCard>
    );
  }
};

export default PasswordResetRequest;
